/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Queue_Linesheets_In_DraftInputs */

const en_queue_linesheets_in_draft = /** @type {(inputs: Queue_Linesheets_In_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Linesheets in draft`)
};

/**
* | output |
* | --- |
* | "Linesheets in draft" |
*
* @param {Queue_Linesheets_In_DraftInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const queue_linesheets_in_draft = /** @type {((inputs?: Queue_Linesheets_In_DraftInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Queue_Linesheets_In_DraftInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_queue_linesheets_in_draft(inputs)
});